import { Users } from "lucide-react";
import { ROLE_LABELS, useTeam } from "@/lib/team";

export default function AssistantBanner() {
  const { isAssistant, role, ownerName } = useTeam();
  if (!isAssistant) return null;
  return (
    <div className="mb-4 flex items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-xs text-blue-900" data-testid="assistant-banner">
      <Users className="h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0">
        Working in <b>{ownerName}</b>'s account · <span data-testid="assistant-role">{ROLE_LABELS[role]}</span> assistant
      </span>
    </div>
  );
}
